/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Sign_Out_SuccessInputs */

const en_users_sign_out_success = /** @type {(inputs: Users_Sign_Out_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User signed out.`)
};

const pt_br2_users_sign_out_success = /** @type {(inputs: Users_Sign_Out_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usuário desconectado.`)
};

/**
* | output |
* | --- |
* | "User signed out." |
*
* @param {Users_Sign_Out_SuccessInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_sign_out_success = /** @type {((inputs?: Users_Sign_Out_SuccessInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Sign_Out_SuccessInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_sign_out_success(inputs)
	return pt_br2_users_sign_out_success(inputs)
});